import { Container, Flex, Heading } from "@radix-ui/themes";
import { PropsWithChildren } from "react";
import useAppLogo from "../../assets/use-app-icon.png";

type AuthRootProps = PropsWithChildren<{
  title: string;
}>;

export function AuthRoot({ title, children }: AuthRootProps) {
  return (
    <Container size="1" p="2">
      <Flex direction="column" gap="6" align="center">
        <img src={useAppLogo} className="shared-logo" alt="Use logo" />
        <Heading>{title}</Heading>
        <Flex direction="column" gap="4" width="100%" maxWidth="320px">
          {children}
        </Flex>
      </Flex>
    </Container>
  );
}
